import pluralize from "./pluralize"

export default function (str, ...vals) {
    for (let key in vals) {
        str = str.replace(new RegExp(`\\{${key}\\}`, "gi"), vals[key]);
    }
    return pluralize(str, vals);
}